import { computed, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RsOverviewServerSideStateManager } from '@rs-shared-lib/abstract-classes/rs-overview-state/rs-overview-server-side-state-manager';
import { RsPersistOverviewState } from '@rs-shared-lib/abstract-classes/rs-overview-state/persistency/rs-persist-overview-state.decorator';
import { rsCountFilters } from '@rs-shared-lib/utils/count-filters/count-filters';
import { ServerSideQueryParams } from '@rs-shared-lib/abstract-classes/rs-overview-state/models/rs-overview-server-side-state-manager';
import { UserService } from '@core/services/user.service';
import { TranslationService, RsUtils } from '@lib/rs-ngx';
import { environment } from '@environments/environment';
import { LinkedActivitySummary } from '@app/leasing-company/maintenance-intervals/shared/linked-activity-summary';
import { MRT_DEFAULT_PAGE_SIZE, MRT_PAGE_SIZE_OPTIONS } from '@shared/constants/mrt-page-size-options';
import { rsReloadAfterDeletion } from '@shared/utils/rs-reload-after-deletion';

export type LinkedActivitiesFilters = {
  activityCodeFrom: string;
  activityCodeTo: string;
  activityDescription: string;
  linkedActivityCodeFrom: string;
  linkedActivityCodeTo: string;
  linkedActivityDescription: string;
};

@RsPersistOverviewState({
  storageKeySuffix: 'MrtLeasingCompanyLinkedActivities',
  includeUserContext: () => inject(UserService).getCurrentUser()!.loginString,
})
@Injectable()
export class LinkedActivitiesOverviewStateService extends RsOverviewServerSideStateManager<LinkedActivitySummary, LinkedActivitiesFilters> {
  public readonly filterCount = computed(() => rsCountFilters(this.filters()));

  public reloadAfterDeletion(deletedCount = 1): void {
    rsReloadAfterDeletion(this, deletedCount);
  }

  constructor() {
    const http = inject(HttpClient);
    const currentLanguage = inject(TranslationService).currentLang;

    super({
      serviceMethod: (params: ServerSideQueryParams<LinkedActivitiesFilters>) => {
        return http.get<LinkedActivitySummary[]>(`${environment.apiUrl}/leasing-company/linked-activity`, {
          params: RsUtils.trimEmptyHttpParams({
            ...params,
            _userLanguage: currentLanguage(),
          }),
          observe: 'response',
        });
      },
      initialSortingState: { active: 'ACTIVITY_DESCRIPTION', direction: 'asc' },
      initialFiltersState: {
        activityCodeFrom: '',
        activityCodeTo: '',
        activityDescription: '',
        linkedActivityCodeFrom: '',
        linkedActivityCodeTo: '',
        linkedActivityDescription: '',
      },
      initialPagination: { pageIndex: 0, pageSize: MRT_DEFAULT_PAGE_SIZE },
      config: { pageSizeOptions: MRT_PAGE_SIZE_OPTIONS },
    });
  }
}
